export let GoogleRecaptchaActionTypes;

(function (GoogleRecaptchaActionTypes) {
  GoogleRecaptchaActionTypes["UpdateRecaptchaToken"] = "[Google Recaptcha] Update Recaptcha Token";
  GoogleRecaptchaActionTypes["RequestRecaptchaTokenFailed"] = "[Google Recaptcha] Request Recaptcha Token Failed";
})(GoogleRecaptchaActionTypes || (GoogleRecaptchaActionTypes = {}));